import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import SortOption from '~/constants/common/SortOption';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import useIsFromSearchBar from '~/hooks/srp/useIsFromSearchBar';

export default function useResetSortOnNewSearch() {
  const { appliedFilters, isSortUserSelected, setSortBy } = useContext(
    AppliedFiltersContext
  );
  const isFromSearchBar = useIsFromSearchBar();

  // Read via ref so the effect doesn't re-fire when the user picks a sort
  // (which sets isSortUserSelected = true). That re-fire would be a no-op but
  // would also run on every future filter/source change, defeating the guard.
  const isSortUserSelectedRef = useRef(isSortUserSelected);
  isSortUserSelectedRef.current = isSortUserSelected;

  useSubsequentEffect(() => {
    if (
      (Object.keys(appliedFilters).length === 0 || isFromSearchBar) &&
      !isSortUserSelectedRef.current
    ) {
      setSortBy(SortOption.MostPopular);
    }
  }, [appliedFilters, isFromSearchBar, setSortBy]);
}
